import React from "react";
import AdminAnalyticsContent from "../FunctionComponents/AdminAnalytics/AdminAnalyticsContent";

function AdminAnalytics() {
  return (
    <>
      <AdminAnalyticsContent />
    </>
  );
}

export default AdminAnalytics;